class NormalizedPoint {
  x: number;
  y: number;

  isTop: boolean;
  isBottom: boolean;

  isLeft: boolean;
  isRight: boolean;

  constructor(
    pointX: number,
    pointY: number,
    containerWidth: number,
    containerHeight: number
  ) {
    this.x = pointX / containerWidth;
    this.y = pointY / containerHeight;

    this.isTop = this.y < 0.5;
    this.isBottom = !this.isTop;

    this.isLeft = this.x < 0.5;
    this.isRight = !this.isLeft;
  }
}

/**
 * Given a DOMRect, determines which quadrant of the container each corner of the rect is in.
 * @param rect - The rect to obtain the points for
 * @param container - The container the rect points are relative to (defaults to window)
 */
export function pointsForRect(
  rect: DOMRect,
  container = { width: window.innerWidth, height: window.innerHeight }
) {
  const { top, right, bottom, left } = rect;
  const { width, height } = container;

  return {
    topLeft: new NormalizedPoint(left, top, width, height),
    topRight: new NormalizedPoint(right, top, width, height),
    bottomLeft: new NormalizedPoint(left, bottom, width, height),
    bottomRight: new NormalizedPoint(right, bottom, width, height),
  };
}
